(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review-testimonial"] && !Shopify.designMode) return;
  try {
    (function () {
    const carousel = document.querySelector('[data-review-carousel]');
    if (!carousel) return;

    const container = carousel.querySelector('[data-carousel-container]');
    if (!container) return;

    // Get all slides (they should already be wrapped by review_item.liquid)
    let slides = container.querySelectorAll('.review-testimonial__slide');

    // If no slides found, try to find review items and wrap them
    if (slides.length === 0) {
      const reviewItems = container.querySelectorAll('[data-block-type="review_item"]');
      reviewItems.forEach((item, index) => {
        item.classList.add('review-testimonial__slide');
        item.setAttribute('data-slide-index', index);
        if (index === 0) {
          item.classList.add('review-testimonial__slide--active');
        }
      });
      slides = container.querySelectorAll('.review-testimonial__slide');
    } else {
      // Ensure first slide is active and set data-slide-index
      slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', index);
        if (index === 0) {
          slide.classList.add('review-testimonial__slide--active');
        } else {
          slide.classList.remove('review-testimonial__slide--active');
        }
      });
    }

    // Generate navigation dots if needed
    const navContainer = carousel.querySelector('[data-navigation-container]');
    if (navContainer && slides.length > 1) {
      navContainer.innerHTML = '';
      for (let i = 0; i < slides.length; i++) {
        const dot = document.createElement('div');
        dot.className = `review-testimonial__nav-dot ${i === 0 ? 'review-testimonial__nav-dot--active' : ''}`;
        dot.setAttribute('data-dot-index', i);
        navContainer.appendChild(dot);
      }
    }

    // Re-query dots after generating them
    let dots = carousel.querySelectorAll('.review-testimonial__nav-dot');

    if (slides.length <= 1) return;

    let currentIndex = 0;
    let intervalId = null;

    function showSlide(index) {
      // Re-query slides and dots in case DOM changed
      slides = container.querySelectorAll('.review-testimonial__slide');
      dots = carousel.querySelectorAll('.review-testimonial__nav-dot');

      // Remove active class from all slides
      slides.forEach((slide) => {
        slide.classList.remove('review-testimonial__slide--active');
      });

      // Remove active class from all dots
      dots.forEach((dot) => {
        dot.classList.remove('review-testimonial__nav-dot--active');
      });

      // Add active class to current slide
      if (slides[index]) {
        slides[index].classList.add('review-testimonial__slide--active');
      }

      // Add active class to current dot
      if (dots[index]) {
        dots[index].classList.add('review-testimonial__nav-dot--active');
      }

      currentIndex = index;
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }

    function startCarousel() {
      intervalId = setInterval(nextSlide, 4000); // 4 seconds
    }

    function stopCarousel() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    // Add click handlers to dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        stopCarousel();
        showSlide(index);
        startCarousel();
      });
    });

    // Start the carousel
    startCarousel();

    // Pause on hover (optional)
    carousel.addEventListener('mouseenter', stopCarousel);
    carousel.addEventListener('mouseleave', startCarousel);
  })();

  (function yotpoReviewTestimonialLive() {
    if (window.__yotpoReviewTestimonialInited) return;
    var blocks = document.querySelectorAll('.review-testimonial-block[data-yotpo-live="true"]');
    if (blocks.length === 0) return;
    var appKey = blocks[0].getAttribute('data-yotpo-app-key');
    if (!appKey) return;
    window.__yotpoReviewTestimonialInited = true;
    var apiUrl = 'https://api.yotpo.com/products/' + appKey + '/yotpo_site_reviews/bottomline';
    fetch(apiUrl)
      .then(function (res) { return res.ok ? res.json() : Promise.reject(); })
      .then(function (data) {
        var bottomline = data.response && data.response.bottomline;
        if (!bottomline) return;
        var rating = parseFloat(bottomline.average_score || bottomline.average_rating) || 0;
        if (rating <= 0) return;
        var full = Math.floor(rating);
        var hasHalf = (rating % 1) >= 0.5;
        var starHtml = '';
        for (var i = 0; i < 5; i++) {
          if (i < full) {
            starHtml += '\u2605';
          } else if (i === full && hasHalf) {
            starHtml += '<span class="review-testimonial__star-half">\u2605</span>';
          } else {
            starHtml += '\u2606';
          }
        }
        blocks.forEach(function (block) {
          var starsEl = block.querySelector('[data-yotpo-stars]');
          if (starsEl) {
            starsEl.classList.add('review-testimonial__stars--live');
            starsEl.innerHTML = starHtml;
          }
        });
      })
      .catch(function () {});
  })();
  } catch(e) { console.error(e); }
})();

})();
